@if (items.length > 0) {
  <div class="dedup">
    @if (pendingCount > 0) {
      <div class="dedup__header">
        <div class="dedup__icon" aria-hidden="true"><i class="ph ph-warning"></i></div>
        <div class="dedup__head-text">
          <div class="dedup__title">
            @if (pendingCount === 1 && config.titleKeyOne) {
              {{ config.titleKeyOne | translate: { count: pendingCount } }}
            } @else {
              {{ config.titleKey | translate: { count: pendingCount } }}
            }
          </div>
          @if (expanded) {
            <div class="dedup__subtitle">
              @if (pendingCount === 1 && config.subtitleKeyOne) {
                {{ config.subtitleKeyOne | translate }}
              } @else {
                {{ config.subtitleKey | translate }}
              }
            </div>
          }
        </div>
        @if (expanded) {
          <button type="button" class="dedup__link" (click)="expanded = false">
            {{ 'tenders.responses.documents.dedup.reduce' | translate }}
          </button>
        } @else {
          <ex-button type="primary" size="large" (click)="expanded = true">
            {{ 'tenders.responses.documents.dedup.resolve' | translate }}
          </ex-button>
        }
      </div>
    }

    @if (expanded) {
      <div class="dedup__list">
        @for (item of items; track item.uid) {
          <div
            class="dedup__row"
            [class.dedup__row--resolved]="item.resolution"
            [class.dedup__row--collapsing]="item.phase === 'collapsing'"
          >
            @if (item.resolution) {
              <div class="dedup__resolved" [class.dedup__resolved--replace]="item.resolution === 'replace'">
                <span class="dedup__resolved-icon" aria-hidden="true">
                  <i class="ph" [ngClass]="item.resolution === 'replace' ? 'ph-check' : 'ph-x'"></i>
                </span>
                <span class="dedup__resolved-text">{{ resolvedLabel(item) | translate }}</span>
                <span class="dedup__resolved-name">· {{ item.name }}</span>
              </div>
            } @else {
              <div class="dedup__doc">
                @let ext = fileExt(item.name);
                @let extColor = fileExtColor(item.name);
                <span class="dedup__doc-icon" [style.color]="extColor" [style.background-color]="extColor + '1A'" aria-hidden="true">
                  {{ ext }}
                </span>
                <div class="dedup__doc-info">
                  <div class="dedup__doc-name">{{ item.name }}</div>
                  <div class="dedup__doc-meta">{{ metaLine(item) }}</div>
                </div>
                <div class="dedup__actions">
                  <button type="button" class="dedup__btn dedup__btn--secondary" (click)="decide(item, secondaryAction)">
                    {{ labelFor(secondaryAction) | translate }}
                  </button>
                  <button type="button" class="dedup__btn dedup__btn--primary" (click)="decide(item, primaryAction)">
                    {{ labelFor(primaryAction) | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
